import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UsersManagementComponent } from './users-management/users-management.component';
import { ManageUsersDialogComponent } from './manage-users-dialog/manage-users-dialog.component';
import { TenantsManagementComponent } from './tenants-management/tenants-management.component';
import { ManageTenantDialogComponent } from './manage-tenant-dialog/manage-tenant-dialog.component';
import { TenantConfirmDialogComponent } from './tenant-confirm-dialog/tenant-confirm-dialog.component';



@NgModule({
  declarations: [
    UsersManagementComponent,
    ManageUsersDialogComponent,
    TenantsManagementComponent,
    ManageTenantDialogComponent,
    TenantConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatStepperModule,
    MatSnackBarModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
    RouterModule,
    MatTableModule,
    MatSortModule,
    MatCardModule,
    FlexLayoutModule,
    MatPaginatorModule,
    NgxMatSelectSearchModule
  ]
})
export class UserManagementModule { }
